export default function getResource(label, vars = []) {
    const resources = {
        phone: 'Téléphone',
        phoneNumber: 'Numéro de téléphone',
        edit: 'Modifier',
        remove: 'Retirer',
        confirmPhoneLabel: 'Confirmer le numéro de téléphone*',
        cancel: 'Annuler',
        update: 'Enregistrer',
        and: ' et ',
        emptyPhoneMessage: 'Veuillez remplir ce champ.',
        invalidConfirmationMessage: 'Veuillez vous assurer que les numéros de téléphone entrés correspondent',
        invalidPhoneMessage: 'Veuillez entrer un numéro de téléphone valide',
        phoneNumberRejected: 'Type de téléphone non valide. Veuillez vérifier votre saisie ou utiliser des données valides.',
        marketingCheckbox: 'Inscrivez-moi aux alertes par texto de Sephora',
        disclosure: 'Divulgation des alertes par texto Sephora : ',
        by: 'En ',
        entering: 'entrant votre numéro de téléphone, ',
        checkingThe: 'vérifiant le ',
        textStopAddress: ' Sephora : 160, rue Bloor Est, Bureau 1100, Toronto (Ontario) M4W 0A2, Canada. 1-877-737-4672.',
        clicking: `En cliquant sur le bouton « ${vars[0]} » et en confirmant votre inscription, vous consentez à recevoir des messages publicitaires automatiques récurrents, y compris des rappels de panier abandonné, et confirmez que vous avez lu et accepté les`,
        textTerm: ' MODALITÉS DES TEXTOS.',
        message: ' La fréquence des messages varie. Le consentement n’est pas une condition d’achat. Des frais de messagerie texte et de données peuvent s’appliquer. Consultez notre ',
        privacy: 'POLITIQUE DE CONFIDENTIALITÉ',
        noticeOf: 'AVIS DE PRIME FINANCIÈRE',
        textStop: ' Textez ARRET pour annuler en tout temps. AIDE pour obtenir de l’aide.',
        InFoDescription: 'Si vous vous étiez inscrit(e) aux alertes par texto de Sephora avec votre ancien numéro de téléphone, votre abonnement sera annulé. Inscrivez-vous avec votre nouveau numéro pour ne rien manquer.',
        InfoModaltitle: 'Avis de désabonnement',
        GotIt: 'Compris',
        sephoraTexts: 'Alertes par texto de Sephora',
        notSubscribed: 'Vous n’avez pas d’abonnement',
        subscribed: 'Inscrit',
        subscribe: 'S’abonner',
        subscribeContinue: 'Continuer',
        unsubscribe: 'Se désabonner',
        subscribeInfoTitle: 'S’abonner aux alertes par texto de Sephora',
        unsubscribeInfoTitle: 'Se désabonner des alertes par texto de Sephora',
        unsubscribeInfoDescription: 'Voulez-vous vraiment vous désabonner des alertes par texto de Sephora pour ce numéro de téléphone?',
        unsubscribeInfoDescription2: 'Vous pourriez manquer des aubaines et des nouveautés exclusives pour les membres Beauty Insider.',
        add: 'Ajouter',
        noPhone: 'Aucun numéro de téléphone enregistré'
    };
    return resources[label];
}
